import React, { useRef, useState } from 'react';
import HookForm from '../../../../components/HookForm/HookForm';
import { MASK } from '../../../../constants/mask';
import useIbanAutofill from '../../../../hooks/useIbanAutofill';

const RequisitesForm = ({ onSubmit, currentData }) => {
  const [requisitesForm, setRequisitesForm] = useState([
    {
      name: 'bankAccount',
      label: 'Номер банковского счёта',
      placeholder: 'KZT5004100100',
      rules: { 
        required: true,
        validate: (value) => {
          value = value.replace(/_/g, '');
          if (!value || value.length !== 20) {
            return 'Номер банковского счёта должен содержать 20 символов';
          }
          return true;
        }
      },
      mask: MASK.IBAN,
      defaultValue: currentData?.bankAccount,
    },
    {
      name: 'bankName',
      label: 'Наименование банка',
      placeholder: 'АО "Банк"',
      rules: { required: true },
      defaultValue: currentData?.bankName,
    },
    {
      name: 'bankBic',
      label: 'БИК',
      placeholder: 'KCJBKZKX',
      rules: { 
        required: true,
        validate: (value) => {
          value = value?.replace(/_/g, '');
          if (!value || value?.length !== 8) {
            return 'БИК должен содержать 8 символов';
          }
          return true;
        }
      },
      mask: [/[A-Za-z]/, /[A-Za-z]/, /[A-Za-z]/, /[A-Za-z]/, /[A-Za-z]/, /[A-Za-z]/, /[A-Za-z]/, /[A-Za-z]/],
      maxLength: 8,
      defaultValue: currentData?.bankBic,
      transform: (value) => value?.toUpperCase(),
    },
    // {
    //   name: 'bankAddress',
    //   label: 'Адрес банка',
    //   placeholder: 'г. Алматы, ул. Банковская, д. 1',
    //   rules: { required: true },
    //   value: currentData?.bankAddress,
    // },
    // {
    //   name: 'correspondentAccount',
    //   label: 'Корреспондентский счёт',
    //   placeholder: 'KZ987654321098765432',
    //   value: currentData?.correspondentAccount,
    // },
    // {
    //   name: 'kbe',
    //   label: 'КБе (код назначения платежа)',
    //   placeholder: '17',
    //   type: 'select',
    //   options: [
    //     { value: '17', label: '17 - Текущий счёт' },
    //     { value: '15', label: '15 - Депозитный счёт' },
    //     { value: '19', label: '19 - Прочие счета' },
    //   ],
    //   rules: { required: true },
    //   value: currentData?.kbe,
    // },
    // {
    //   name: 'accountCurrency',
    //   label: 'Валюта счёта',
    //   type: 'select',
    //   options: [
    //     { value: 'KZT', label: 'Тенге (KZT)' },
    //     { value: 'USD', label: 'Доллар США (USD)' },
    //     { value: 'EUR', label: 'Евро (EUR)' },
    //     { value: 'RUB', label: 'Российский рубль (RUB)' },
    //   ],
    //   rules: { required: true },
    //   value: currentData?.accountCurrency || 'KZT',
    // },
    // {
    //   name: 'paymentPurpose',
    //   label: 'Назначение платежа',
    //   placeholder: 'Оплата за автомобиль по договору выкупа',
    //   value: currentData?.paymentPurpose,
    // },
  ]);

  const formRef = useRef(null);
  // Поля здесь названы иначе, чем в договоре поручения, — передаём свои имена.
  const ibanAutofill = useIbanAutofill(formRef, {
    iban: 'bankAccount',
    bank: 'bankName',
    bic: 'bankBic',
  });

  const handleSubmit = (values) => {
    if (onSubmit) {
      onSubmit(values);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <HookForm
        ref={formRef}
        onValuesChange={ibanAutofill}
        inputs={requisitesForm}
        title={'Банковские реквизиты'}
        grid={{ display: 'grid', gap: '20px', gridTemplateColumns: '1fr 1fr 1fr' }}
        handlerSetState={setRequisitesForm}
        onSubmit={handleSubmit}
        action={'Далее'}
        border
      />
    </div>
  );
};

export default RequisitesForm; 